import { useDispatch } from 'react-redux';

import appActions from 'redux/actions/app-actions/app.actions';
import { useCancelScheduledOrderMutation } from 'features/order/scheduled/hooks';

import { useSOCancelDialogLang } from './useSOCancelDialogLang';

interface Props {
  orderId: number;
  onCanceled: () => void;
  onFailed: () => void;
}

export function useSOCancelDialog({ orderId, onCanceled, onFailed }: Props) {
  const lang = useSOCancelDialogLang();
  const dispatch = useDispatch();
  const { mutate, isLoading } = useCancelScheduledOrderMutation();

  const handleSubmit = () => {
    mutate(orderId, {
      onSuccess: () => {
        dispatch(appActions.openSnackBarSuccess(lang.successToast));
        onCanceled();
      },
      onError: () => {
        dispatch(appActions.openSnackBarError(lang.errorToast));
        onFailed();
      },
    });
  };

  return { handleSubmit, isLoading };
}
